import { NavLink } from 'react-router-dom'

import { useAppDispatch } from '../../../store/hooks'
import { openModal } from '../../../store/modal/modal'

import { getUserDisplayName } from '../../../apps/professional-app/fa/common/aifeatures/utils'

import { IntegrationExportButton } from '../../../components/IntegrationExportButton/IntegrationExportButton'
import buttonStyles from '../../../components/Button/Button.module.scss'
import { UserAvatar } from '../../../components/UserAvatar/UserAvatar'

import { IntegrationServiceId } from '../../../common/integrations'
import { User } from '../../../models/User'
import { useCurrentUserIntegrations } from '../../Integration/useCurrentUserIntegrations'

interface DocumentSummaryContactsProps {
  contact: User
}

export const DocumentSummaryContacts: React.FC<DocumentSummaryContactsProps> = ({ contact }) => {
  const dispatch = useAppDispatch()

  const { getContactCreateOrUpdateSupportedIntegrations } = useCurrentUserIntegrations()

  const contactCreateOrUpdateSupportedIntegrations = getContactCreateOrUpdateSupportedIntegrations(contact)

  const handleOpenContactUpdateModal = (serviceId: IntegrationServiceId) => {
    dispatch(openModal({ type: 'updateDocumentContact', serviceId, user: contact }))
  }

  return (
    <>
      <div className='p-4 zocks-border-0.5 border zocks-border-color-gray-300 d-flex flex-column gap-4'>
        <div className='d-flex align-items-center justify-content-between'>
          <span className='paragraph-large bold'>Clients</span>
        </div>
        <div className='d-flex flex-column gap-4'>
          <div className='d-flex align-items-center justify-content-between gap-3 flex-wrap'>
            <div className='d-flex align-items-center gap-3'>
              <UserAvatar
                width='1.5rem'
                height='1.5rem'
                fontSize='0.75rem'
                className='zocks-bg-color-gray-900 zocks-text-white'
                useInitials={true}
                initialLetters={contact.name ? contact.name[0] : ''}
              />
              <NavLink
                className={`${buttonStyles.button} ${buttonStyles.linkButton} button-link-medium `}
                to={`/library/manage-contacts/contacts/${contact.id}`}
                target='_blank'
              >
                <div className='paragraph-medium-extended bold text-truncate mw-100'>
                  <div className='text-truncate'>{getUserDisplayName(contact)}</div>
                </div>
              </NavLink>
            </div>
            <div className='d-flex align-items-center gap-2'>
              {contactCreateOrUpdateSupportedIntegrations.map(({ serviceId }) => (
                <IntegrationExportButton key={serviceId} serviceId={serviceId} onClick={() => handleOpenContactUpdateModal(serviceId)} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
